import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import MuiDialogContent from '@material-ui/core/DialogContent';

import { Scrollbars } from 'react-custom-scrollbars';

const styles = theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 8,
      paddingRight: 8,
      height: 'calc(100vh - 104px)',
      overflowY: 'auto',
    },
  },
  rootDisableGutters: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  scrollbarsDisableGutters: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  scrollbarsFromBottom: {
    // '& > div': {
    //   display: 'flex',
    //   flexDirection: 'column',
    //   justifyContent: 'flex-end',
    // },
  },
  scrollbarsDisableMouseScroll: {
    '& > *': {
      overflow: 'hidden!important',
      marginRight: '0!important',
      marginBottom: '0!important',
    },
  },
  mobileScrollbarsContent: {
    height: '100%',
    overflowY: 'auto',
  },
});

class DialogContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      autoHeightMax: 400,
    };

    this.onScrollbarsUpdate = this.onScrollbarsUpdate.bind(this);
  }

  componentWillMount() {
    this.onScrollbarsUpdate();
    window.addEventListener('resize', this.onScrollbarsUpdate);
  }

  componentWillReceiveProps(nextProps) {
    const { scrollMaxHeightDecrease, width } = this.props;
    const isFullScreen = width === 'xs' || width === 'sm' || nextProps.fullScreen;
    if (nextProps.scrollMaxHeightDecrease !== scrollMaxHeightDecrease) {
      const titleHeight = isFullScreen ? 104 : 190;
      const windowHeight = width === 'xs' || width === 'sm' ? window.screen.height : window.innerHeight;
      this.setState({ autoHeightMax: windowHeight
        - titleHeight - nextProps.scrollMaxHeightDecrease });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onScrollbarsUpdate);
  }

  onScrollbarsUpdate() {
    const { fullScreen, scrollMaxHeightDecrease, width } = this.props;
    const isFullScreen = width === 'xs' || width === 'sm' || fullScreen;
    const titleHeight = isFullScreen ? 104 : 190;
    const windowHeight = width === 'xs' || width === 'sm' ? window.screen.height : window.innerHeight;
    this.setState({ autoHeightMax: windowHeight - titleHeight - scrollMaxHeightDecrease });
  }

  render() {
    const {
      className,
      withScrollbars,
      disableGutters,
      disableMouseScroll,
      fullHeight,
      onScrollFrame,
      scrollbarsRef,
      fromBottom,
      width,
      classes,
    } = this.props;
    return (
      <MuiDialogContent
        classes={{
          root: classNames(classes.root, className, {
            [classes.rootDisableGutters]: disableGutters,
          }),
        }}
      >
        {(withScrollbars === true && width !== 'xs' && width !== 'sm') && (
          <Scrollbars
            className={classNames({
              [classes.scrollbarsDisableGutters]: disableGutters,
              [classes.scrollbarsDisableMouseScroll]: disableMouseScroll,
              [classes.scrollbarsFromBottom]: fromBottom,
            })}
            autoHeight
            autoHeightMin={fullHeight ? this.state.autoHeightMax : 0}
            autoHeightMax={this.state.autoHeightMax}
            thumbMinSize={30}
            universal
            onScrollFrame={onScrollFrame}
            ref={scrollbarsRef}
          >
            {this.props.children}
          </Scrollbars>
        )}
        {(withScrollbars === false && width !== 'xs' && width !== 'sm') && (
          <Fragment>
            {this.props.children}
          </Fragment>
        )}
        {(width === 'xs' || width === 'sm') && (
          <div
            className={classes.mobileScrollbarsContent}
            {...width === 'xs' || width === 'sm' ? { 
              ref: (node) => {
                if (node) {
                  node.getScrollHeight = () => node.childNodes[0].clientHeight;
                  node.getClientHeight = () => node.clientHeight;
                  node.scrollToBottom = () => node.scrollTop = node.scrollHeight;
                  scrollbarsRef(node);
                }
              },
              onScroll: (event) => {
                event.top = (event.target.scrollTop + event.target.clientHeight) / event.target.scrollHeight;
                onScrollFrame(event);
              },
            } : {}}
          >
            {this.props.children}
          </div>
        )}
      </MuiDialogContent>
    );
  }
}

DialogContent.propTypes = {
  className: PropTypes.string,
  withScrollbars: PropTypes.bool,
  fullScreen: PropTypes.bool,
  fullHeight: PropTypes.bool,
  disableGutters: PropTypes.bool,
  disableMouseScroll: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onScrollFrame: PropTypes.func,
  scrollbarsRef: PropTypes.func,
  scrollMaxHeightDecrease: PropTypes.number,
  fromBottom: PropTypes.bool,
  classes: PropTypes.shape({
    rootDisableGutters: PropTypes.string.isRequired,
    scrollbarsDisableGutters: PropTypes.string.isRequired,
    scrollbarsDisableMouseScroll: PropTypes.string.isRequired,
  }).isRequired,
};

DialogContent.defaultProps = {
  className: '',
  withScrollbars: false,
  fullScreen: false,
  fullHeight: false,
  disableGutters: false,
  disableMouseScroll: false,
  fromBottom: false,
  scrollMaxHeightDecrease: 0,
  onScrollFrame: () => {},
  scrollbarsRef: () => {},
};

export default withWidth()(withStyles(styles)(DialogContent));



// WEBPACK FOOTER //
// ./src/components/common/Dialog/DialogContent.js